export default __webpack_public_path__ + "static/media/36I-117134_-37271_0.4ecd21ab.jpg";